import { useTheme } from "@up/data";

import {
  CrossPartnerMarketingOptIn,
  Under18MarketingConsent,
} from "./form-fields";

import type { UseFormRegister } from "react-hook-form";

export const Legal = ({
  age,
  isDomestic,
  isStrictUSState,
  isStudent,
  register,
}: {
  age: string;
  isDomestic: boolean;
  isStrictUSState: boolean;
  isStudent: boolean;
  register: UseFormRegister<any>;
}) => {
  const theme = useTheme();
  const ageIsSet = !isNaN(Number(age));
  const isUnder18 = ageIsSet && parseInt(age) < 18;
  const shouldShowUnder18Consent = (() => {
    if (!isDomestic) {
      return true; // Always show for international
    }

    if (isStudent && isUnder18) {
      return true; // Show for domestic students under 18
    }

    return false; // Hide for all other cases
  })();

  return (
    <>
      {shouldShowUnder18Consent ? (
        <>
          <Under18MarketingConsent
            partnerOnlineName={theme.partnerOnlineName}
            register={register}
          />
          <hr />
        </>
      ) : null}

      {(isStrictUSState && isUnder18) || !isDomestic ? null : (
        <>
          <CrossPartnerMarketingOptIn register={register} />
          <hr />
        </>
      )}

      {isDomestic ? (
        <p className="text-sm" data-testid="privacy-policy-text-domestic">
          By pressing &quot;Request Info&quot; below, which you acknowledge is
          your electronic signature and legally valid, you agree to the{" "}
          {theme.partnerOnlineName}{" "}
          <a href="/privacy-policy" className="underline">
            Privacy Policy
          </a>{" "}
          (
          <a
            href="/privacy-policy-addendum-for-california-residents"
            className="underline"
          >
            California Notice At Collection
          </a>
          ), which governs the processing and handling of your data. You (or
          your parent/guardian) may revoke this consent at any time by
          contacting our service provider at{" "}
          <a
            className="underline"
            href="mailto:privacy.universitypartners@kaplan.com"
          >
            privacy.universitypartners@kaplan.com
          </a>
          .
        </p>
      ) : (
        <p className="text-sm" data-testid="privacy-policy-text-international">
          By pressing &quot;Request Info&quot; below, which you acknowledge is
          your electronic signature and legally valid, you agree to the{" "}
          {theme.partnerOnlineName}{" "}
          <a href="/privacy-policy" className="underline">
            Privacy Policy
          </a>
          , which governs the processing and handling of your data, and consent
          to the transfer of your data to the United States. Emails are sent by{" "}
          {theme.partnerName}'s service provider Kaplan North America, LLC, 1515
          W. Cypress Creek Road, Fort Lauderdale, FL 33309. You (or your
          parent/guardian) may revoke your consent or unsubscribe by contacting
          Kaplan North America at{" "}
          <a href="mailto:privacy.universitypartners@kaplan.com">
            privacy.universitypartners@kaplan.com
          </a>
          .
        </p>
      )}
    </>
  );
};
